export default __webpack_public_path__ + "2go.5cfc7061d16d69add13ab06c664d8b97.svg";